<template>
    <div class="page">
        <p>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br />
            {{ userStore.user.address }}
            <br />
            {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
            <br />
            <br />
            {{ creditor.creditor_name }}
            <br />
            <template v-if="creditor.address">
                {{ creditor.address }}
            </template>
            <template v-else>
                {{ creditor.address_line }}<br /> {{ creditor.city }}, {{ creditor.state }} {{ creditor.zipcode }}
            </template>
            <br />
            <br />
            Date: {{ date }}
        </p>
        <p>
            RE: Account # {{ lodash.join(lodash.map(accounts, 'account_number'), ', ') }}
        </p>
        <p>
            To Whom It May Concern:
        </p>
        <p class="letter-content">
            This is a formal request for a detailed procedure list used when your company allegedly verified account number # {{ lodash.join(lodash.map(accounts, 'account_number'), ', ') }}. I am appalled that your company is still reporting incorrect information to the credit bureaus and damaging my credit reputation.
        </p>
        <p class="letter-content">
            Please provide me with any document in your files bearing my signature, where I agreed to pay this alleged debt. If you can’t provide this, then you can’t report it according to the FCRA. Also I would like to see a detailed history of all transactions on this account, including but NOT limited to all payments, returns, debits, interest, credits, etc. Again, if you can’t provide this information within a timely manner, then you can’t report it according to the FCRA & FCBA.
        </p>
        <p class="letter-content">
            I believe that 30 days is sufficient enough time for you to be able to provide this information to me. I would like to clarify that this is NOT a verification of my name and mailing address. It is quite evident that you have that already. Instead, this letter is a formal request for complete verification of account number {{ lodash.join(lodash.map(accounts, 'account_number'), ', ') }} and of the responsible party obligated to this account.
        </p>
        <p class="letter-content">
            Please give this matter the time and attention it warrants.
        </p>
        <p>
            Thank you for your time and attention to this matter.
            <br />
            <br />
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
        </p>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    import lodash from 'lodash'
    export default {
        props: {
            accounts: {
                type: [Array, Object]
            },
            creditor: {
                type: [Array, Object]
            }
        },
        setup(props) {
            return {
                date: ref(moment().format('LL')),
                userStore: useUserStore(),
                lodash: lodash
            };
        }
    };
</script>